
// import BtnBlack from '~/sections/vision/ai-workspace/btn-black.vue'
export default {
  name: 'AiWorkspaceInitiatives',
  // components: {
  //   BtnBlack
  // },
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
